import { Box, Paper, Typography } from '@mui/material';

interface CardLayouDetailstProps {
    title: string;
    children: React.ReactNode;
}
function CardLayoutDetails(props: CardLayouDetailstProps) {
  const { title, children } = props;
  return (<>
    <Box mt={5} minWidth={610}>
      <Paper variant='outlined' 
        sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent' }}>
        <Typography m={2} variant='h3'>{title}</Typography>
        <Box m={1} minWidth={610}
          sx={{backgroundColor: 'transparent' }}>
          {children}
        </Box>
      </Paper>
    </Box>
  </>);
}

export default CardLayoutDetails;